import { TbPaperBag } from "react-icons/tb";
import { ORDER_STATUS_AWAITING_PAYMENT, ORDER_STATUS_CANCELED, ORDER_STATUS_DONE, ORDER_STATUS_EXPEDITED, ORDER_STATUS_EXPIRED, ORDER_STATUS_MOUNTING, ORDER_STATUS_OPEN, ORDER_STATUS_PENDING, ORDER_STATUS_RELEASED_SHIPMENT, ORDER_STATUS_RELEASED_TAKEAWAY, ORDER_STATUS_RETURNED, ORDER_STATUS_SCHEDULED } from "./Checkout";
import { LABEL_DELIVERY, LABEL_DINE_IN, LABEL_SCHEDULING, LABEL_STORE_COUNTER, LABEL_TAKEAWAY, ORDER_TYPE_DELIVERY, ORDER_TYPE_DELIVERY_ID, ORDER_TYPE_DINE_IN, ORDER_TYPE_DINE_IN_ID, ORDER_TYPE_MENU_ID, ORDER_TYPE_SCHEDULING, ORDER_TYPE_SCHEDULING_ID, ORDER_TYPE_STORE_COUNTER, ORDER_TYPE_STORE_COUNTER_ID, ORDER_TYPE_TAKEAWAY, ORDER_TYPE_TAKEAWAY_ID } from "./Service";
import { MdRestaurantMenu } from "react-icons/md";

export const ORDER_CART_NOT_FOUND = 'order_not_found';

export const ORDER_TYPE_IDS: { [key: string]: number | null } = {
    'delivery': ORDER_TYPE_DELIVERY_ID,
    'takeaway': ORDER_TYPE_TAKEAWAY_ID,
    'dine_in': ORDER_TYPE_DINE_IN_ID,
    'scheduling': ORDER_TYPE_SCHEDULING_ID,
    'store_counter': ORDER_TYPE_STORE_COUNTER_ID,
    'menu': ORDER_TYPE_MENU_ID,
    'default': null,
}

export const ORDER_TYPE_NAME_BY_ID: { [key: number]: string } = {
    [ORDER_TYPE_DELIVERY_ID]: ORDER_TYPE_DELIVERY,
    [ORDER_TYPE_TAKEAWAY_ID]: ORDER_TYPE_TAKEAWAY,
    [ORDER_TYPE_DINE_IN_ID]: ORDER_TYPE_DINE_IN,
    [ORDER_TYPE_SCHEDULING_ID]: ORDER_TYPE_SCHEDULING,
    [ORDER_TYPE_STORE_COUNTER_ID]: ORDER_TYPE_STORE_COUNTER
}

export const getOrderColorByStatusId = (orderStatus: number): string => {
    let typeBadge = '';
    switch (orderStatus) {
        case ORDER_STATUS_CANCELED: typeBadge = 'error'; break;
        case ORDER_STATUS_PENDING: typeBadge = 'default'; break;
        case ORDER_STATUS_OPEN: typeBadge = 'info'; break;
        case ORDER_STATUS_MOUNTING: typeBadge = 'required'; break;
        case ORDER_STATUS_RELEASED_SHIPMENT: typeBadge = 'success'; break;
        case ORDER_STATUS_EXPEDITED: typeBadge = 'alert'; break;
        case ORDER_STATUS_RETURNED: typeBadge = 'error'; break;
        case ORDER_STATUS_DONE: typeBadge = 'success'; break;
        case ORDER_STATUS_RELEASED_TAKEAWAY: typeBadge = 'success'; break;
        case ORDER_STATUS_SCHEDULED: typeBadge = 'required'; break;
        case ORDER_STATUS_AWAITING_PAYMENT: typeBadge = 'alert'; break;
        case ORDER_STATUS_EXPIRED: typeBadge = 'required'; break;
        default: break;
    }
    return typeBadge;
}

export const getOrderTypeLabelById = (orderTypeId: number | null): string | null => {
    const idToLabelMap: { [key: number]: string } = {
      [ORDER_TYPE_DELIVERY_ID]: LABEL_DELIVERY,
      [ORDER_TYPE_TAKEAWAY_ID]: LABEL_TAKEAWAY,
      [ORDER_TYPE_DINE_IN_ID]: LABEL_DINE_IN,
      [ORDER_TYPE_SCHEDULING_ID]: LABEL_SCHEDULING,
      [ORDER_TYPE_STORE_COUNTER_ID]: LABEL_STORE_COUNTER,
    };
    return orderTypeId !== null ? idToLabelMap[orderTypeId] || null : null;
}

export const TAKEOUT_OPTIONS_TAKEAWAY = 'takeaway';
export const TAKEOUT_OPTIONS_DINE_IN = 'dine_in';

export const getTakeawayOptionLabel = (option: string) => {
    switch (option) {
        case TAKEOUT_OPTIONS_TAKEAWAY:
            return  LABEL_TAKEAWAY //'Levar'
        case TAKEOUT_OPTIONS_DINE_IN:
            return LABEL_DINE_IN // 'Comer no local'
        default:
            return '';
    }
}

export const getTakeoutModeOptions = () => {
    return [
        {option: TAKEOUT_OPTIONS_TAKEAWAY, label: getTakeawayOptionLabel(TAKEOUT_OPTIONS_TAKEAWAY), icon: <TbPaperBag />},
        {option: TAKEOUT_OPTIONS_DINE_IN, label: getTakeawayOptionLabel(TAKEOUT_OPTIONS_DINE_IN), icon: <MdRestaurantMenu />},
    ]
}